import React, { Component, useState, } from "react"
import get_and_post_data_skeleton from '../common/common/get_and_post_data_skeleton';
import getGeoInfo from '../common/common/getGeoInfo';
import CreatePriceStr from '../common/common/CreatePriceStr';
import {
   FaTwitter, FaInstagram, FaFacebookMessenger, FaFacebook, FaLinkedin
} from 'react-icons/fa';
import { styled } from '@mui/material/styles';
import { Box, Button, Chip, CircularProgress, Grid, IconButton, Modal, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Tooltip, Typography, useMediaQuery } from '@mui/material';
import '../../css/Referrals.css';
import SnackbarAlert from '../common/SnackbarAlert';
import Fade from "react-reveal/Fade";
import { MdPersonSearch } from "react-icons/md";
import ReferralAnimation from "../Elements/ReferralAnimation";
import ReferralAnimationMobile from "../Elements/ReferralAnimationMobile";
import ReferralsCalculator from "../Elements/ReferralsCalculator";
import ReferralsBanner from "./Referrals/ReferralsBanner";
import theme from "../../theme";
import { TbMoodSad } from "react-icons/tb";
import PageSkeletonReferrals from '../common/skeletons/PageSkeletonReferrals';
import { PiFileDashedThin } from "react-icons/pi";
import { PiSmileySad } from "react-icons/pi";
import ReferralsExamples from './Referrals/ReferralsExamples';

const paths = require('../../paths.json');

const modalStyle = {
   display: 'flex',
   height: 'auto',
   // bgcolor: 'rgba(0,0,0,1)',
   minHeight: '100vh',
   minWidth: '100vw',
   overflowY: 'hidden',
   outline: 'none',
   zIndex: '9999',
};

const demoData = [
   {
      id: 1,
      username: "JohnDoe",
      date_added: "2023-12-05",
      status: "success"
   },
   {
      id: 2,
      username: "JaneSmith",
      date_added: "2023-12-01",
      status: "pending"
   },
   {
      id: 3,
      username: "BobJones",
      date_added: "2023-11-28",
      status: "success"
   },
   {
      id: 4,
      username: "SarahWilliams",
      date_added: "2023-11-25",
      status: "pending"
   },
   {
      id: 5,
      username: "MikeJohnson",
      date_added: "2023-11-20",
      status: "success"
   },
   {
      id: 6,
      username: "EmilyBrown",
      date_added: "2023-11-15",
      status: "success"
   }
];

const timeline = [
   {
      name: 'Invite 💌',
      description:
         'Share your unique referral link or email creators personally',
      date: 'Step 1',
      dateTime: '2021-08',
   },
   {
      name: 'Register 📝',
      description:
         'Wait patiently for them to register with WithMe & Setup their account',
      date: 'Step 2',
      dateTime: '2021-12',
   },
   {
      name: 'Earn 💰',
      description:
         'As soon as your referral starts earning money, so do you!',
      date: 'Step 3',
      dateTime: '2022-02',
   },
]

const Item = styled(Paper)(({ theme }) => ({
   backgroundColor: window.innerWidth <= 1280 ? '#fff' : '#fff',
   ...theme.typography.body2,
   textAlign: window.innerWidth <= 1280 ? 'center' : 'right',
   width: window.innerWidth <= 1280 ? '13%' : '15%',
   padding: window.innerWidth <= 1280 ? '10px' : '',
   boxShadow: 'none',
   color: 'var(--brand-color)',
}));
function ReferralTable({ data, active_referrals, monthly_income, total_income, currency }) {
   const [page, setPage] = useState(0);
   const [rowsPerPage, setRowsPerPage] = useState(5);
   const [copySuccess, setCopySuccess] = useState("");
   const [isFading, setIsFading] = useState(false);
   const [showDemoData, setShowDemoData] = useState(false);
   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

   // Demo data for testing
   const demoData = [
      {
         id: 1,
         username: "JaneSmith",
         date_added: "2023-12-01",
         status: "success"
      },
      {
         id: 2,
         username: "JohnDoe",
         date_added: "2023-11-29",
         status: "pending"
      },
      {
         id: 3,
         username: "SarahWilson",
         date_added: "2023-11-28",
         status: "success"
      }
   ];

   const handleChangePage = (event, newPage) => {
      setIsFading(true);
      setTimeout(() => {
         setIsFading(false);
         setPage(newPage);
      }, 500);
   };

   const handleChangeRowsPerPage = (event) => {
      setIsFading(true);
      setTimeout(() => {
         setIsFading(false);
         setRowsPerPage(parseInt(event.target.value, 10));
         setPage(0);
      }, 500);
   };

   const displayData = showDemoData ? demoData : data;
   const rowsToShow = displayData && displayData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

   return (
      <div style={{ width: '100%', backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #E4EBF6', padding: isMobile ? '15px' : '20px', boxSizing: 'border-box' }}>
         <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', alignItems: isMobile ? 'flex-start' : 'center', marginBottom: '20px' }}>
            <div style={{ flex: '1 1 auto' }}>
               <h1 style={{ fontSize: isMobile ? '16px' : '18px', fontWeight: '600', color: '#222222', margin: '0px 0px 0px 0px', fontFamily: 'var(--main-font-family)' }}>Your Referrals</h1>
               <p style={{ marginTop: '8px', fontSize: '14px', color: '#6E89AF', marginBottom: '10px', fontWeight: '500' }}>
                  Earn passive income every time you refer a creator friend who joins WithMe. When a referral signs up, you'll earn 20% of their subscription fee, in perpetuity. 
                  {/* And for Q1 only you will also receive our Growth Programme, worth $1000! */}

                  Discover the impact of your referrals - see how they've stacked up below
               </p>
            </div>
            {/* <div style={{ marginTop: isMobile ? '10px' : '0' }}>
               <Button
                  variant="outlined"
                  onClick={() => setShowDemoData(!showDemoData)}
                  sx={{
                     textTransform: 'none',
                     color: 'var(--brand-color)',
                     borderColor: 'var(--brand-color)',
                     '&:hover': {
                        borderColor: 'var(--brand-color-hover)',
                        backgroundColor: 'transparent'
                     }
                  }}
               >
                  {showDemoData ? 'Show Real Data' : 'Show Demo Data'}
               </Button>
            </div> */}
         </div>

         <Grid container spacing={isMobile ? 1 : 2} sx={{ justifyContent: 'space-between', marginBottom: '20px' }}>
            <Grid item xs={12} sm={4}>
               <div style={{ padding: '15px 15px', backgroundColor: '#F5F9FF', borderRadius: '8px' }}>
                  <span style={{ fontWeight: '500', color: '#6D89AF', fontSize: '14px' }}>Active Referrals</span>
                  <p style={{
                     margin: '5px 0 0 0',
                     color: '#222222',
                     fontSize: isMobile ? '16px' : '18px',
                     fontWeight: '600',
                  }}>{showDemoData ? 2 : active_referrals}</p>
               </div>
            </Grid>

            <Grid item xs={12} sm={4}>
               <div style={{ padding: '15px 15px', backgroundColor: '#F5F9FF', borderRadius: '8px' }}>
                  <span style={{ fontWeight: '500', color: '#6D89AF', fontSize: '14px' }}>Monthly Earnings</span>
                  <p style={{
                     margin: '5px 0 0 0',
                     color: '#222222',
                     fontSize: isMobile ? '16px' : '18px',
                     fontWeight: '600',
                  }}>{CreatePriceStr(showDemoData ? 250 : monthly_income, currency)}</p>
               </div>
            </Grid>

            <Grid item xs={12} sm={4}>
               <div style={{ padding: '15px 15px', backgroundColor: '#F5F9FF', borderRadius: '8px' }}>
                  <span style={{ fontWeight: '500', color: '#6D89AF', fontSize: '14px' }}>Total Earnings</span>
                  <p style={{
                     margin: '5px 0 0 0',
                     color: '#222222',
                     fontSize: isMobile ? '16px' : '18px',
                     fontWeight: '600',
                  }}>{CreatePriceStr(showDemoData ? 1250 : total_income, currency)}</p>
               </div>
            </Grid>
         </Grid>

         <div style={{ paddingTop: '20px', position: 'relative', paddingBottom: isMobile ? '60px' : '0px' }}>
            {(!displayData || displayData.length === 0) ? (
               <div style={{ padding: '40px 0', textAlign: 'center', backgroundColor: '#fff', width: '100%' }}>
                                <TbMoodSad size={48} color="#9CA3B4" style={{ padding: '10px 0px' }} />
                  <h3 style={{
                     marginTop: '8px',
                     fontSize: '14px',
                     fontWeight: '600',
                     color: '#1D1D1D',
                     fontFamily: 'Roboto, sans-serif'
                  }}>No Referrals Yet</h3>
                  <p style={{
                     marginTop: '4px',
                     fontSize: '14px',
                     color: '#9CA3B4',
                     fontWeight: '500',
                     fontFamily: 'Roboto, sans-serif'
                  }}>Share your referral link to start earning.</p>
               </div>
            ) : isMobile ? (
               // Mobile card view with updated styling
               <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                  {rowsToShow.map((row) => (
                     <div key={row.id} style={{ padding: '15px', border: '1px solid #E4EBF6', borderRadius: '8px' }}>
                        <div style={{ marginBottom: '10px' }}>
                           <span style={{
                              fontSize: '14px',
                              fontWeight: '500',
                              color: '#222222'
                           }}>{row.username}</span>
                        </div>
                        <div style={{ 
                           display: 'flex', 
                           justifyContent: 'space-between', 
                           alignItems: 'center'
                        }}>
                           <span style={{
                              fontSize: '14px',
                              color: '#6E89AF'
                           }}>{row.date_added}</span>
                           <Chip
                              label={row.status}
                              sx={{
                                 backgroundColor: row.status === 'success' ? '#E6F4EA' : '#FFF4E5',
                                 color: row.status === 'success' ? '#34A853' : '#F5A623',
                                 textTransform: 'capitalize',
                                 fontWeight: '500',
                                 fontSize: '12px'
                              }}
                           />
                        </div>
                     </div>
                  ))}
               </div>
            ) : (
               // Desktop table view
               <div>
                  <div style={{ width: '100%', overflowX: 'auto' }}>
                     <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                           <tr>
                              <th scope="col" style={{
                                 padding: '14px 12px',
                                 textAlign: 'left',
                                 fontSize: '14px',
                                 fontWeight: '600',
                                 color: '#222222',
                                 borderBottom: '1px solid #E4EBF6'
                              }}>Creator</th>
                              <th scope="col" style={{
                                 padding: '14px 12px',
                                 textAlign: 'left',
                                 fontSize: '14px',
                                 fontWeight: '600',
                                 color: '#222222',
                                 borderBottom: '1px solid #E4EBF6'
                              }}>Date Added</th>
                              <th scope="col" style={{
                                 padding: '14px 12px',
                                 textAlign: 'left',
                                 fontSize: '14px',
                                 fontWeight: '600',
                                 color: '#222222',
                                 borderBottom: '1px solid #E4EBF6'
                              }}>Status</th>
                           </tr>
                        </thead>
                        <tbody>
                           {rowsToShow.map((row) => (
                              <tr key={row.id} style={{ borderBottom: '1px solid #E4EBF6' }}>
                                 <td style={{
                                    whiteSpace: 'nowrap',
                                    padding: '16px 12px',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    color: '#222222'
                                 }}>{row.username}</td>
                                 <td style={{
                                    whiteSpace: 'nowrap',
                                    padding: '16px 12px',
                                    fontWeight: '500',
                                    fontSize: '14px',
                                    color: '#6E89AF'
                                 }}>{row.date_added}</td>
                                 <td style={{
                                    whiteSpace: 'nowrap',
                                    padding: '16px 12px',
                                    fontSize: '14px',
                                 }}>
                                    <Chip
                                       label={row.status}
                                       sx={{
                                          backgroundColor: row.status === 'success' ? '#E6F4EA' : '#FFF4E5',
                                          color: row.status === 'success' ? '#34A853' : '#F5A623',
                                          textTransform: 'capitalize',
                                          fontWeight: '500',
                                          fontSize: '12px'
                                       }}
                                    />
                                 </td>
                              </tr>
                           ))}
                        </tbody>
                     </table>
                  </div>
                  <Box sx={{
                     display: 'flex',
                     justifyContent: 'flex-end',
                     mt: 2
                  }}>
                     <TablePagination
                        rowsPerPageOptions={isMobile ? [5] : [5, 10, 25]}
                        component="div"
                        count={displayData ? displayData.length : 0}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        sx={{
                           '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
                              fontSize: '14px'
                           }
                        }}
                     />
                  </Box>
               </div>
            )}
         </div>
      </div>
   );
}


function handleCopyToClipboard(text) {
   navigator.clipboard.writeText(text)
      .then(() => {
         // console.log('Text copied to clipboard:', text);
         // You can display a success message or perform any other desired action
      })
      .catch((error) => {
         // console.error('Error copying text to clipboard:', error);
         // You can display an error message or perform any other desired action
      });
}

class Referrals extends Component {
   constructor(props) {
      super(props);
      this.state = {
         screenWidth: window.innerWidth,
         influencer_id: '',
         influencer_referral_code: '',
         active_referral_info: [],
         active_referrals: 0,
         total_income: 0,
         monthly_income: 0,
         page_num: 0,
         n_rows_per_page: 5,
         errorMsg: '',
         successMsg: '',
         snackbar: false,
         isCodeCopied: false,
         emailList: [],
         emailReferralInput: '',
         copy_text: 'Copy',
         show_error_text: false,
         userCurrency: '£',
         currency: 'GBP',
         currencySymbol: '£',
         upload_loading: false
      };
      this.handleChangePage = this.handleChangePage.bind(this);
      this.get_and_post_data = this.get_and_post_data.bind(this);
      this.postEmailSends = this.postEmailSends.bind(this);
      this.handleEmailSends = this.handleEmailSends.bind(this);
      this.getGeoInfo = this.getGeoInfo.bind(this);
   }

   componentDidMount() {
      window.addEventListener('resize', this.handleResize);
      let currency = this.getGeoInfo(true);
      
      this.get_and_post_data(
         paths.BACKEND_URL + "api/settings_page_referrals/" + currency,
         'get',
         false,
         (response) => {
            if (response && response.data) {
               this.setState({
                  active_referral_info: response.data.referrals || [],
                  active_referrals: response.data.active_referrals || 0,
                  monthly_income: response.data.monthly_income || 0,
                  total_income: response.data.total_income || 0,
                  influencer_id: response.data.influencer_id || '',
                  influencer_referral_code: response.data.referral_code || '',
                  currency: response.data.currency || 'GBP',
                  currencySymbol: response.data.currency === 'GBP' ? '£' : '$',
                  upload_loading: false
               }, () => {
                  this.countActiveReferrals(response.data.referrals || []);
               });
            } else {
               this.setState({
                  errorMsg: 'Failed to load referral data',
                  snackbar: true,
                  upload_loading: false
               });
            }
         }
      );
   }

   componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
   }

   handleResize = () => {
      this.setState({ screenWidth: window.innerWidth });
   };

   handleChangePage(event, newPage) {
      this.setState({ page_num: newPage })
   };

   get_and_post_data = get_and_post_data_skeleton

   emailValidation(email) {
      const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      if (!email || regex.test(email) === false) {
         this.setState({
            errorMsg: "Please enter a valid email",
            show_error_text: true
         })

         return false;
      }
      return true;
   }

   handleNewEmailAdded = async () => {

      if (this.emailValidation(this.state.emailReferralInput)) {
         await this.setState(prevState => ({
            emailList: [...prevState.emailList, this.state.emailReferralInput]
         }))
         this.setState({
            emailReferralInput: ''
         })
      } else {
         console.log('email invalid')
      }

   }

   handleEmailSends() {
      const form_data = new FormData();
      this.setState({
         upload_loading: true,
      });
      form_data.append('emails', this.state.emailList);
      form_data.append('referral_code', "https://withme.so/become-a-creator?id=" + this.state.influencer_id + '&code=' + this.state.influencer_referral_code);
      this.get_and_post_data(
         paths.BACKEND_URL + "api/settings_page_referrals_send_emails",
         'post',
         false,
         form_data,
         this.postEmailSends,
      );
   }

   postEmailSends(res) {
      if (res.data.success) {
         this.setState({
            emailList: [],
            successMsg: 'Emails sent!',
            couponSuccess: true,
            upload_loading: false
         });
      } else {
         this.setState({
            successMsg: 'Error please try again.',
            couponSuccess: true,
            upload_loading: false
         });
      }
   }

   handleRemoveItem = async (index) => {
      this.setState(prevState => ({
         emailList: prevState.emailList.filter((_, i) => i !== index)
      }));
   }

   EmailChipList = () => {

      return (
         <>
            <div style={{ display: 'flex', marginTop: '10px', flexFlow: 'wrap', width: '100%' }}>
               {this.state.emailList && this.state.emailList.map((emailName, index) => (
                  <Fade>
                     <Chip label={emailName}
                        key={index}
                        sx={{
                           backgroundColor: '#F2F7FF',
                           color: 'var(--brand-color)',
                           marginRight: '5px',
                           marginBottom: '10px',
                           fontWeight: '500',
                           '&:hover': {
                              backgroundColor: 'var(--brand-color-hover)',
                              color: '#fff',
                           }
                        }}
                        // onClick={() => console.log(index)}
                        onDelete={() => this.handleRemoveItem(index)}
                     />
                  </Fade>
               ))}
            </div>
         </>
      )

   }

   countActiveReferrals(data) {
      let count = 0;

      for (let i = 0; i < data.length; i++) {
         if (data[i].status === 'active') {
            count++;
         }
      }

      this.setState({
         active_referrals: count
      });
   }

   getGeoInfo = getGeoInfo

   render() {
      const { screenWidth, loading, active_referrals, monthly_income, total_income, currency } = this.state;

      const referralLink = "https://withme.so/become-a-creator?id=" + this.state.influencer_id
      return (
         <>
            {loading ?
               <PageSkeletonReferrals />
               :
               <div>
                  <Grid
                     Container
                     xs={12}
                     justifyContent="center"
                     sx={{
                        margin: 'auto'
                     }}
                  >
                     {
                        this.state.upload_loading ?
                           <Modal open={this.state.upload_loading}>
                              <Box style={modalStyle}
                                 sx={{
                                    display: 'flex', width: '100%', height: '100%',
                                    margin: 'auto'
                                 }}>
                                 <Grid
                                    container
                                    spacing={0}
                                    direction="column"
                                    alignItems="center"
                                    justifyContent="center"
                                    style={{ minHeight: '90vh' }}
                                 >
                                    <CircularProgress sx={{
                                       color: 'var(--brand-color)',
                                    }} />

                                    <p style={{
                                       color: 'var(--primary-text-color)',
                                       fontSize: 'var(--medium-text)',
                                       fontWeight: '600',
                                    }}>Sending Emails...</p>
                                 </Grid>
                              </Box>
                           </Modal>
                           :
                           <div>

                           </div>
                     }

                     {/* Referral Dashboard */}
                     <div>
                        <ReferralTable data={this.state.active_referral_info} active_referrals={this.state.active_referrals} monthly_income={this.state.monthly_income} total_income={this.state.total_income} currency={this.state.currency} />


                        <div style={{ margin: '40px 0px 50px 0px', backgroundColor: '#fff', padding: '20px', borderRadius: '8px', border: '1px solid #E4EBF6' }}>

                           <p style={{ fontSize: '18px', margin: '0px 0px 10px 0px' }}><strong>Share your referral link</strong></p>
                           <p style={{ marginTop: '8px', fontSize: '14px', color: '#6E89AF', marginBottom: '20px', fontWeight: '500' }}>
                              Copy your unique referral link or share it via social media.
                           </p>

                           {
                              screenWidth <= 1280 ?
                                 // Mobile /Tablet Version
                                 <Grid container>
                                    <Grid xs={12}>
                                       <input type="text" className={'text-input email-field'} id={"emailCaptureInput"}
                                          style={{
                                             border: '1px solid #D9DADB', display: 'block', fontWeight: '500',
                                             margin: '0px auto 10px 0px', fontSize: '16px', boxSizing: 'border-box',
                                             padding: '10px 15px', color: '#3B55F3', borderRadius: '5px',
                                             width: '100%', fontFamily: 'Roboto'
                                          }}
                                          value={"https://withme.so/become-a-creator?id=" + this.state.influencer_id} />

                                       <Button variant="contained" disableElevation
                                          onClick={() => {
                                             handleCopyToClipboard(referralLink);
                                             this.setState({
                                                copy_text: 'Copied!'
                                             })
                                          }}
                                          sx={{
                                             padding: '2px 25px',
                                             width: '100%',
                                             textAlign: 'center',
                                             minWidth: '100%',
                                             display: 'inline-block',
                                             margin: 'auto 0px auto auto',
                                             borderRadius: '10px',
                                             border: '2px #fff solid',
                                             boxSizing: 'border-box',
                                             textTransform: 'none',
                                             backgroundColor: 'var(--brand-color)',
                                             color: '#fff',
                                             '&:hover': {
                                                backgroundColor: 'var(--brand-color-hover)', color: '#fff',
                                             }
                                          }}
                                       >
                                          <span style={{ fontWeight: '600', fontSize: '16px', minWidth: '40px' }}>{this.state.copy_text}</span>
                                       </Button>
                                    </Grid>

                                    <Grid lg={12} sx={{ width: '100%', margin: '20px auto 10px auto' }}>
                                       <p style={{ fontWeight: '500', color: '#6D89AF', fontSize: '16px', margin: '5px 0px 15px 0px' }}>
                                          Or share via social media 👇
                                       </p>
                                       <Stack direction="row" justifyContent={'space-between'}>
                                          <Item sx={{ '&:hover #icon': { color: 'var(--brand-color-hover)', cursor: 'pointer' } }}>
                                             <a id={'icon'} style={{ color: 'var(--brand-color)' }} target={'_blank'}
                                                href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(referralLink)}`}>
                                                <FaTwitter id={'icon'} style={{ fontSize: '26px', height: '100%', }} />
                                             </a>
                                          </Item>
                                          <Item sx={{ '&:hover #icon': { color: 'var(--brand-color-hover)', cursor: 'pointer' } }}>
                                             <a id={'icon'} style={{ color: 'var(--brand-color)' }} target={'_blank'}
                                                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(referralLink)}`}>
                                                <FaFacebook style={{ fontSize: '26px', height: '100%' }} />
                                             </a>
                                          </Item>
                                          <Item sx={{ '&:hover #icon': { color: 'var(--brand-color-hover)', cursor: 'pointer' } }}>
                                             <a id={'icon'} style={{ color: 'var(--brand-color)' }} target={'_blank'}
                                                href={`fb-messenger://share/?link=${encodeURIComponent(referralLink)}`}>
                                                <FaFacebookMessenger id={'icon'} style={{ fontSize: '26px', height: '100%' }} />
                                             </a>
                                          </Item>
                                          <Item sx={{ '&:hover #icon': { color: 'var(--brand-color-hover)', cursor: 'pointer' } }}>
                                             <a id={'icon'} style={{ color: 'var(--brand-color)' }} target={'_blank'}
                                                href={`https://www.instagram.com/?url=${encodeURIComponent(referralLink)}`}>
                                                <FaInstagram id={'icon'} style={{ fontSize: '26px', height: '100%' }} />
                                             </a>
                                          </Item>
                                          <Item sx={{ '&:hover #icon': { color: 'var(--brand-color-hover)', cursor: 'pointer' } }}>
                                             <a id={'icon'} style={{ color: 'var(--brand-color)' }} target={'_blank'}
                                                href={`https://www.linkedin.com/shareArticle?url=${encodeURIComponent(referralLink)}`}>
                                                <FaLinkedin id={'icon'} style={{ fontSize: '26px', height: '100%', }} />
                                             </a>
                                          </Item>
                                       </Stack>
                                    </Grid>
                                 </Grid>
                                 :
                                 <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                    <div style={{ width: '600px', flexShrink: 0 }}>
                                       <form style={{
                                          backgroundColor: '#ffffff',
                                          color: '#fff',
                                          borderRadius: '10px',
                                          padding: '3px 3px',
                                          display: 'flex',
                                          border: '1px solid #D9DADB',
                                          width: '100%',
                                          zIndex: '10',
                                          boxSizing: 'border-box'
                                       }}>
                                          <input type="text" className={'text-input-with-button email-field'}
                                             style={{
                                                border: 'none',
                                                padding: '0px 0px 0px 10px',
                                                width: '100%',
                                                fontWeight: '500',
                                                color: '#3B55F3',
                                                fontSize: '16px',
                                                fontFamily: 'Roboto',
                                                WebkitMaskImage: 'linear-gradient(to right, black 75%, transparent 95%)',
                                                maskImage: 'linear-gradient(to right, black 75%, transparent 95%)'
                                             }}
                                             value={"https://withme.so/become-a-creator?id=" + this.state.influencer_id} />
                                          {
                                             screenWidth > 1280 &&
                                             <Button variant="contained" disableElevation
                                                onClick={() => {
                                                   handleCopyToClipboard(referralLink);
                                                   this.setState({
                                                      copy_text: 'Copied!'
                                                   })
                                                }}
                                                sx={{
                                                   padding: '2px 15px',
                                                   width: 'auto',
                                                   textAlign: 'center',
                                                   minWidth: '40px',
                                                   display: 'inline-block',
                                                   margin: 'auto 0px auto auto',
                                                   borderRadius: '8px',
                                                   border: '2px #fff solid',
                                                   boxSizing: 'border-box',
                                                   textTransform: 'none',
                                                   backgroundColor: 'var(--brand-color)',
                                                   color: '#fff',
                                                   '&:hover': {
                                                      backgroundColor: 'var(--brand-color-hover)', color: '#fff',
                                                   }
                                                }}
                                             >
                                                <span style={{ fontWeight: '600', fontSize: '14px', minWidth: '40px', maxWidth: '40px' }}>{this.state.copy_text}</span>
                                             </Button>
                                          }
                                       </form>
                                    </div>

                                    <Stack direction="row" spacing={1} sx={{ flexShrink: 0 }}>
                                       <Item sx={{ '&:hover #icon': { color: 'var(--brand-color-hover)', cursor: 'pointer' }, width: 'auto', padding: '5px' }}>
                                          <a id={'icon'} style={{ color: 'var(--brand-color)' }} target={'_blank'}
                                             href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(referralLink)}`}>
                                             <FaTwitter id={'icon'} style={{ fontSize: '20px', height: '100%', }} />
                                          </a>
                                       </Item>
                                       <Item sx={{ '&:hover #icon': { color: 'var(--brand-color-hover)', cursor: 'pointer' }, width: 'auto', padding: '5px' }}>
                                          <a id={'icon'} style={{ color: 'var(--brand-color)' }} target={'_blank'}
                                             href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(referralLink)}`}>
                                             <FaFacebook style={{ fontSize: '20px', height: '100%' }} />
                                          </a>
                                       </Item>
                                       <Item sx={{ '&:hover #icon': { color: 'var(--brand-color-hover)', cursor: 'pointer' }, width: 'auto', padding: '5px' }}>
                                          <a id={'icon'} style={{ color: 'var(--brand-color)' }} target={'_blank'}
                                             href={`fb-messenger://share/?link=${encodeURIComponent(referralLink)}`}>
                                             <FaFacebookMessenger id={'icon'} style={{ fontSize: '20px', height: '100%' }} />
                                          </a>
                                       </Item>
                                       <Item sx={{ '&:hover #icon': { color: 'var(--brand-color-hover)', cursor: 'pointer' }, width: 'auto', padding: '5px' }}>
                                          <a id={'icon'} style={{ color: 'var(--brand-color)' }} target={'_blank'}
                                             href={`https://www.instagram.com/?url=${encodeURIComponent(referralLink)}`}>
                                             <FaInstagram id={'icon'} style={{ fontSize: '20px', height: '100%' }} />
                                          </a>
                                       </Item>
                                       <Item sx={{ '&:hover #icon': { color: 'var(--brand-color-hover)', cursor: 'pointer' }, width: 'auto', padding: '5px' }}>
                                          <a id={'icon'} style={{ color: 'var(--brand-color)' }} target={'_blank'}
                                             href={`https://www.linkedin.com/shareArticle?url=${encodeURIComponent(referralLink)}`}>
                                             <FaLinkedin id={'icon'} style={{ fontSize: '20px', height: '100%', }} />
                                          </a>
                                       </Item>
                                    </Stack>
                                 </div>
                           }
                        </div>

                        <div style={{ margin: '40px 0px 50px 0px', backgroundColor: '#fff', padding: '20px', borderRadius: '8px', border: '1px solid #E4EBF6' }}>
                           <p style={{ fontSize: '18px', margin: '0px 0px 10px 0px' }}><strong>How it works - Simple as 1-2-3 👇</strong></p>
                           <p style={{ marginTop: '8px', fontSize: '14px', color: '#6E89AF', marginBottom: '20px', fontWeight: '500' }}>
                              In just three simple steps, you can start earning money from your referrals.
                           </p>
                           {/* Timeline section */}
                           <div style={{
                              margin: '30px auto 0px auto',
                              position: 'relative',
                              fontFamily: 'Roboto',
                           }}>
                              <div style={{
                                 margin: '0 auto',
                                 display: 'flex',
                                 gap: '40px',
                                 overflow: 'hidden',
                                 position: 'relative',
                                 flexDirection: screenWidth <= 768 ? 'column' : 'row',
                                 '@media (min-width: 1024px)': {
                                    margin: '0',
                                    maxWidth: 'none',
                                    gridTemplateColumns: 'repeat(4, 1fr)'
                                 }
                              }}>
                                 {timeline.map((item) => (
                                    <div key={item.name} style={{ width: screenWidth <= 768 ? '100%' : '33%' }}>
                                       <time
                                          dateTime={item.dateTime}
                                          style={{
                                             display: 'flex',
                                             alignItems: 'center',
                                             fontSize: '14px',
                                             lineHeight: '24px',
                                             fontWeight: '600',
                                             color: '#4f46e5',
                                             position: 'relative'
                                          }}
                                       >
                                          <svg
                                             viewBox="0 0 4 4"
                                             aria-hidden="true"
                                             style={{
                                                marginRight: '16px',
                                                width: '4px',
                                                height: '4px',
                                                flexShrink: 0
                                             }}
                                          >
                                             <circle r={2} cx={2} cy={2} fill="currentColor" />
                                          </svg>
                                          <span style={{ backgroundColor: '#ffffff', borderRadius: '5px', paddingRight: '10px', zIndex: '499' }}>{item.date}</span>
                                          {screenWidth > 768 && (
                                             <div
                                                aria-hidden="true"
                                                style={{
                                                   position: 'absolute',
                                                   right: '-25px',
                                                   top: '12px',
                                                   height: '1px',
                                                   width: '100%',
                                                   background: 'linear-gradient(to right, rgba(17, 24, 39, 0.1), rgba(255, 255, 255, 0))',
                                                   '@media (min-width: 1024px)': {
                                                      left: 'auto',
                                                      right: '0px',
                                                      width: '100%'
                                                   }
                                                }}
                                             />
                                          )}
                                       </time>
                                       <p style={{
                                          marginTop: '12px',
                                          marginBottom: '10px',
                                          marginLeft: '20px',
                                          fontSize: '18px',
                                          lineHeight: '32px',
                                          fontWeight: '600',
                                          letterSpacing: '-0.025em',
                                          color: '#111827'
                                       }}>
                                          {item.name}
                                       </p>
                                       <p style={{
                                          marginTop: '0px',
                                          marginLeft: '20px',
                                          fontSize: '14px',
                                          fontWeight: '500',
                                          lineHeight: '24px',
                                          color: '#6E89AF'
                                       }}>
                                          {item.description}
                                       </p>
                                    </div>
                                 ))}
                              </div>
                           </div>
                        </div>
                     </div>
           
                  </Grid>


                  <SnackbarAlert
                     msg={this.state.successMsg}
                     open={this.state.couponSuccess}
                     snackbarBackgroundColor={'var(--primary-color)'}
                     severity={'success'}
                     handleClose={() => {
                        this.setState({
                           couponSuccess: false
                        })
                     }}
                  />
               </div>
            }
         </>
      )
   }
}

export default Referrals;

